import React from 'react'
import { Text, FlexRow, FlexColumn } from 'elements'

export default function CompanyContent(props) {
  return (
    <FlexRow>
      <FlexColumn mr="gigantic">
        <Text fontSize="medium" mb="medium">
          Company Name
        </Text>
        <Text fontSize="xlarge" lineHeight="xlarge" fontWeight="bold" mb="small">
          {props.company.name}
        </Text>
      </FlexColumn>
      <FlexColumn mr="gigantic">
        <Text fontSize="medium" mb="medium">
          Legal Name
        </Text>
        <Text fontSize="xlarge" fontWeight="bold" mb="small">
          {props.company.legalName}
        </Text>
      </FlexColumn>
    </FlexRow>
  )
}
